/**
 * Canvas System Commands — frontend handlers for canvas UI operations
 * broadcast from tool-runtime via broadcastCmd → pendingCmds → commandRegistryStore.
 *
 * canvas_download — triggers PNG export in the browser for the open canvas window,
 *   optionally scoped to a specific frame.
 */

import { SelfContainedCommand, CommandExecutionContext } from '../../types/commands';
import { StandardToolResult } from '../../types/standardToolResults';
import { createFileLogger } from '../../utils/logger';

const log = createFileLogger('CANVAS_SYSTEM_COMMANDS', { enabled: true });

// ─── canvas_download ──────────────────────────────────────────────────────────

const canvas_download_cmd: SelfContainedCommand = {
  id: 'canvas_download',
  description: 'Trigger a PNG download for an open canvas, optionally scoped to a frame.',
  schema: {
    parameters: [
      { name: 'entityId', type: 'string', required: true,  description: 'Canvas entity ID' },
      { name: 'frameId',  type: 'string', required: false, description: 'Frame element ID to export; omit for full canvas' },
    ],
  },
  handler: async (params: any, _ctx: CommandExecutionContext): Promise<StandardToolResult> => {
    const { entityId, frameId } = params;
    log.info('[canvas_download] Dispatching download', { entityId, frameId });
    window.dispatchEvent(
      new CustomEvent('canvas:download', { detail: { entityId, frameId: frameId ?? null } }),
    );
    return { status: 'success', message: 'Canvas download triggered', format: 'plaintext' };
  },
};

export const CANVAS_SYSTEM_COMMANDS: SelfContainedCommand[] = [canvas_download_cmd];
